<template>
	<Container>
		<Subtitle>
			{{ $t('Contratacion_comercial') }}
		</Subtitle>
		<div class="p-4">
			<div class="lg:flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<div class="mb-4">
						<label class="block mb-2">{{ $t('Nombre') }}</label>
						<input
							type="text"
							v-model="delegation.delegation_name"
							class="
								mt-2
								w-full
								border-t-0
								border-r-0
								border-l-0
								border-b
								border-solid
								border-inputGrey
								outline-none
							"
						/>
						<div v-if="$v.delegation.delegation_name.$dirty">
							<div
								class="text-sm text-red-500 mt-2"
								v-if="!$v.delegation.delegation_name.required"
							>
								{{ $t('Campo_requerido') }}
							</div>
						</div>
					</div>
				</div>
				<div class="lg:w-1/2 mb-4 lg:pl-2">
					<label class="block mb-2">{{ $t('Zonas') }}</label>
					<select
						v-model="delegation.zone_id"
						class="
							mt-2
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
						id="language"
					>
						<option
							v-for="(zone, index) in zones"
							:value="zone.id"
							:key="index"
						>
							{{ zone.zone_name }}
						</option>
					</select>
					<div v-if="$v.delegation.zone_id.$dirty">
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.delegation.zone_id.required"
						>
							{{ $t('Campo_requerido') }}
						</div>
					</div>
				</div>
			</div>
			<div class="lg:flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('state') }}</label>
					<select
						v-model="delegation.state_id"
						class="
							mt-2
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
						id="language"
					>
						<option
							v-for="(state, index) in states"
							:value="state.id"
							:key="index"
						>
							{{ state.name }}
						</option>
					</select>
					<div v-if="$v.delegation.state_id.$dirty">
						<div
							class="text-sm text-red-500 mt-2"
							v-if="!$v.delegation.state_id.required"
						>
							{{ $t('Campo_requerido') }}
						</div>
					</div>
				</div>
				<div class="lg:w-1/2 mb-4 lg:pl-2">
					<label class="block mb-2">{{ $t('Telefono_movil') }}</label>
					<input
						type="text"
						v-model="delegation.phone"
						class="
							mt-2
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
				</div>
			</div>
			<div class="lg:flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('Telefono') }}</label>
					<input
						type="text"
						v-model="delegation.cellphone"
						class="
							mt-2
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
				</div>
				<div class="lg:w-1/2 mb-4 lg:pl-2">
					<label class="block mb-2">{{ $t('email') }}</label>
					<input
						type="text"
						v-model="delegation.email"
						class="
							mt-2
							w-full
							border-t-0
							border-r-0
							border-l-0
							border-b
							border-solid
							border-inputGrey
							outline-none
						"
					/>
				</div>
			</div>
			<div class="flex justify-end">
				<ButtonBlack class="mt-4" @click.native="submit">
					<div v-if="loading">
						<pulse-loader
							:loading="loading"
							:color="'#fff'"
							:size="'10px'"
						></pulse-loader>
					</div>
					<div v-else>
						{{ buton_text }}
					</div>
				</ButtonBlack>
			</div>
			<div v-if="error" class="mt-4">
				<p class="text-sm">{{ $t('server_error') }}</p>
				<p class="text-sm text-red-500" v-html="server_error"></p>
			</div>
		</div>
	</Container>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { single } from '@/mixins'
import { fetchZonesSelect } from '@/apollo/zones'
import { fetchStatesSelect } from '@/apollo/states'
import {
	fetchDelegation,
	insertDelegation,
	updateDelegation
} from '@/apollo/delegations'

export default {
	mixins: [single],
	components: {
		PulseLoader
	},
	data() {
		return {
			delegation: {
				delegation_name: '',
				state_id: null,
				zone_id: null,
				cellphone: null,
				phone: null,
				email: null
			},
			zones: [],
			states: []
		}
	},
	apollo: {
		zones: fetchZonesSelect(),
		states: fetchStatesSelect(),
		delegation() {
			const query = fetchDelegation(this.id)
			query.skip = this.id == null
			return query
		}
	},
	methods: {
		async submit() {
			this.startLoadingState()
			this.$v.$touch()
			if (!this.$v.$invalid) {
				;(this.id
					? this.$apollo.mutate(updateDelegation(this.id, this.delegation))
					: this.$apollo.mutate(insertDelegation(this.delegation))
				)
					.then(() => {
						this.stopLoadingState()
						this.$dialog.alert({
							title: 'Éxito',
							body: 'Operación realizada con exitosamente.',
							loader: true
						})
					})
					.catch(error => this.setError(error))
			} else {
				this.setError(this.$t('form_validation'))
			}
		}
	},
	validations() {
		return {
			delegation: {
				delegation_name: {
					required,
					maxLength: maxLength(50)
				},
				zone_id: {
					required
				},
				state_id: {
					required
				}
			}
		}
	}
}
</script>
